/* tslint:disable:max-line-length */
import * as React from 'react';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var cafeIcon =
/*#__PURE__*/
// eslint-disable-next-line react/forbid-elements
_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  className: styles['icon-cafe'],
  viewBox: "0 0 20 20",
  width: "20",
  height: "20",
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M7.49 8.5C6.292 6.2 13.78.6 5.992.5c4.493 1.9-2.396 7 1.498 8zm3.394 0c-.7-1.5 2.596-4.2.2-5 .6 1.4-2.596 4.2-.2 5zm7.688 3c-.5-.8-1.498-1.2-2.596-1.2v-.4c0-.2-.2-.3-.3-.3H1.3c-.2 0-.3.2-.3.3 0 2.1.4 4 1.198 5.7.8 1.8 1.997 3.1 3.395 3.9h5.69c.9-.5 1.698-1.2 2.397-2.2 2.596 0 4.493-1.6 4.992-3.1.5-.9.4-1.9-.1-2.7zm-1.398 2.2c-.3.8-1.198 1.6-2.496 1.9.5-1.1.9-2.4 1.098-3.7h.1c.6 0 1 .2 1.198.5.3.4.3.8.1 1.3z"
  })
});